import React from "react";
import "../styles/cart.scss";
import SelectedNumber from "./layout/selectedNumber";

/**
 * 
 * @param {{
 *  cart: {
 *      number: number,
 *      amount: number
 *  }[],
 *  onSubtract: (number: number) => void,
 *  readonly?: boolean,
 *  numberLength?: number
 * }} props 
 */
export default function Bets({ cart, onSubtract, readonly, numberLength }) {
    if (!onSubtract) onSubtract = () => undefined;

    return cart.length ?
        <main className="cart-rifa__bets">
            {
                cart.map(({ number, amount }) =>
                    <React.Fragment>
                        <div className="cart-rifa__bet">
                            <SelectedNumber number={number} amount={amount} onRemove={() => onSubtract(number)} readonly={readonly} numberLength={numberLength} />
                        </div>
                    </React.Fragment>
                )
            }
        </main>
        : <div className="cart-rifa__no-bets">
            Seu carrinho está vazio.
        </div>;
}


// WEBPACK FOOTER //
// ./src/rifa/components/bets.jsx